import React from 'react';
import Page from '../components/Page';
import { FormattedMessage } from 'react-intl';

const Equipe = (props) => {
   return(
      <Page bg="/assets/img/equipe-bg.jpg">
         <h1><FormattedMessage id="equipe.h1"/></h1>
         <ul>
            <li><strong><FormattedMessage id="equipe.ul.li1.strong"/></strong><FormattedMessage id="equipe.ul.li1.content"/></li>
            <li><strong><FormattedMessage id="equipe.ul.li2.strong"/></strong><FormattedMessage id="equipe.ul.li2.content"/></li>
            <li><strong><FormattedMessage id="equipe.ul.li3.strong"/></strong><FormattedMessage id="equipe.ul.li3.content"/></li>
            <li><strong><FormattedMessage id="equipe.ul.li4.strong"/></strong><FormattedMessage id="equipe.ul.li4.content"/></li>
         </ul>
      </Page>
   )
}

export default Equipe;